import React, { useEffect, useMemo, useState } from "react";
import KapalService from "../../services/kapal/KapalService";

const ChecklistTipe = ({ kodeTipe }) => {

    let kapalService = useMemo(() => new KapalService(), [])
    const [uraianTipe, setUraianTipe] = useState('')

    useEffect(() => {
        const getChecklistTipe = async () => {
            const response = await kapalService.checklistTipe(kodeTipe)
            // console.log(response)
            setUraianTipe(response.data.uraianTipe)
        }
        getChecklistTipe()
    }, [kapalService, kodeTipe])

    return (
        <>
            {uraianTipe}
        </>
    )
}

export default ChecklistTipe